var es = {
  "Add Quantity Breaks to your product page": "Añade descuentos por cantidad a tu página de producto",
  "Add Upsell.com to your ": "Agrega Upsell.com a tu ",
  "Add to cart click": "Clic en Añadir al carrito",
  "All time": "Todo el tiempo",
  "and select": "y seleccione",
  "button": "botón",
  "Cart drawer page": "Página del Cajón del carrito",
  "Cart page": "Página del Carrito",
  "Check status": "Verificar estado",
  "Checkout page": "Página de Pago",
  "Checkout click": "Clic en Pago",
  "Click": "Haga clic en",
  "Click on": "Haga clic en",
  "Click the": "Haga clic en el",
  "Custom slot": "Ranura personalizada",
  "Custom slots": "Ranuras personalizadas",
  "Custom Slots": "Ranuras personalizadas",
  "Enable in theme editor": "Activar en el editor de temas",
  "contact support.": "contacte al soporte.",
  "from the right sidebar": "de la barra lateral derecha",
  "Go to App Embeds": "Ir a las integraciones de apps",
  "Go to your Cart drawer page": "Ir a su página del Cajón del carrito",
  "Go to your Cart page": "Ir a su página del Carrito",
  "Go to your Checkout page": "Ir a su página de Pago",
  "Go to your Order status page": "Ir a su página de Estado del pedido",
  "Go to your Post purchase page": "Ir a su página de Post-compra",
  "Go to your Product page": "Ir a su página de Producto",
  "Go to your Thank you page": "Ir a su página de Agradecimiento",
  "items": "artículos",
  "in the left sidebar": "en la barra lateral izquierda",
  "Last 12 months": "Últimos 12 meses",
  "Last 30 days": "Últimos 30 días",
  "Last 365 days": "Últimos 365 días",
  "Last 7 days": "Últimos 7 días",
  "Last 90 days": "Últimos 90 días",
  "Last month": "Último mes",
  "Last year": "Último año",
  "Make sure": "Asegúrese de que",
  "Need assistance? Contact our support team for help.": "¿Necesita ayuda? Contacte a nuestro equipo de soporte.",
  "Order status page": "Página de Estado del pedido",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Nuestra aplicación está experimentando un poco de magia para mejorar su experiencia.",
  "Post purchase page": "Página de Post-compra",
  "Product page": "Página de Producto",
  "Save": "Guardar",
  "Scroll to the bottom and select": "Desplácese hasta el final y seleccione",
  "Select": "Seleccionar",
  "Success. Please continue.": "Éxito. Por favor continúe.",
  "Thank you page": "Página de Agradecimiento",
  "The Upsell.com team.": "El equipo de Upsell.com.",
  "The Upsell.com widget is not placed on ": "El widget de Upsell.com no está colocado en ",
  ". Please follow the steps above or ": ". Por favor siga los pasos anteriores o ",
  "Today": "Hoy",
  "toggle is on": "el interruptor está encendido",
  "Total": "Total",
  "under": "debajo",
  "We apologize for any inconvenience caused,": "Nos disculpamos por cualquier inconveniente causado,",
  "We apologize for any inconvenience caused.": "Nos disculpamos por cualquier inconveniente causado.",
  "We'll be done in a few minutes!": "¡Terminaremos en unos minutos!",
  "We're improving our services!": "¡Estamos mejorando nuestros servicios!",
  "Widget already added": "Widget ya añadido",
  "Yesterday": "Ayer",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Activaste el widget en tu tienda online, pero no lo guardaste en el editor de Upsell",
  "You placed the widget on the ": "Colocó el widget en ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", pero no lo guardó en el editor de Shopify. Por favor vuelva a ",
  " and save the changes.": " y guarde los cambios."
};

export { es as default };
//# sourceMappingURL=es.json.js.map
